import*as o from"react";import"./reset.css";
